module.exports = __webpack_public_path__ + "img/insert2.d9820c5c.gif";